import { __extends } from "tslib";
import { axCoerceString } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
import { ContentElement } from './ContentElement';
var GraphicElement = /** @class */ (function (_super) {
    __extends(GraphicElement, _super);
    function GraphicElement(graphic, elementWidth, elementHeight, elementFormat, eventMirror, textRotation) {
        if (graphic === void 0) { graphic = null; }
        if (elementWidth === void 0) { elementWidth = 15; }
        if (elementHeight === void 0) { elementHeight = 15; }
        if (elementFormat === void 0) { elementFormat = null; }
        if (eventMirror === void 0) { eventMirror = null; }
        if (textRotation === void 0) { textRotation = 'rotate0'; }
        var _this = _super.call(this, undefined, undefined, undefined) || this;
        _this.graphic = graphic;
        _this.elementWidth = +elementWidth;
        _this.elementHeight = +elementHeight;
        _this.elementFormat = elementFormat;
        _this.eventMirror = eventMirror;
        _this.textRotation = axCoerceString(textRotation);
        return _this;
    }
    Object.defineProperty(GraphicElement.prototype, "graphic", {
        // JS -> AS Bindings
        // AS -> JS Bindings
        // _graphic: flash.display.DisplayObject;
        // _elementHeight: number;
        // _elementWidth: number;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/GraphicElement', 'get graphic', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/GraphicElement', 'set graphic', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphicElement.prototype, "elementHeight", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/GraphicElement', 'get elementHeight', '');
            return null;
        },
        set: function (value) {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/GraphicElement', 'set elementHeight', '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphicElement.prototype, "elementWidth", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/engine/GraphicElement', 'get elementWidth', '');
            return null;
        },
        set: function (value) {
            value = +value;
            // @todo
            Debug.throwPIR('playerglobals/text/engine/GraphicElement', 'set elementWidth', '');
        },
        enumerable: true,
        configurable: true
    });
    GraphicElement.forceNativeConstructor = true;
    GraphicElement.forceNativeMethods = true;
    return GraphicElement;
}(ContentElement));
export { GraphicElement };
